'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _changeProviderLink = require('./changeProviderLink.scss');

var _changeProviderLink2 = _interopRequireDefault(_changeProviderLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-script-url */
var ChangeProviderLink = function ChangeProviderLink(props) {
  var text = props.text,
      onClick = props.onClick;


  return _react2.default.createElement(
    'a',
    { href: 'javascript:void(0)', onClick: onClick, className: _changeProviderLink2.default.link },
    text
  );
};
/* eslint-enable no-script-url */

ChangeProviderLink.propTypes = {
  text: _propTypes2.default.node,
  onClick: _propTypes2.default.func
};

exports.default = ChangeProviderLink;